import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { RpmStatusTriangle } from '../../../../../../../../assets/Logos/Icons'

import heartBeatImage from '../../../../../../../../assets/RpmAssets/PNGIcons/heart-beat.png'
import { Ecgicon } from '../../../../../../../../assets/Logos/Icons'


function ECG() {
    let reduxData = useSelector(state => state) ; 
    console.log("Redux Data in RpmProfile: ",reduxData);
    let patientDetails = reduxData.rpmreducer.vitalhistory && 
                            reduxData.rpmreducer.vitalhistory.data.ECG;
    
    
    
    useEffect(() => {
       
      patientDetails = reduxData.rpmreducer.vitalhistory && 
                      reduxData.rpmreducer.vitalhistory.data.ECG;
       
      },[])

      console.log(patientDetails)
    return (
        <div className='blood-pressure-vital-container'>

            <div className="blood-pressure-vital-container_details ecgsection">
            
            {patientDetails!=undefined && patientDetails.length>0?(

                <table>
                    <tr>
                    <td></td>
                    <th>Pulse Rate</th>
                    <th>RRI Max</th>
                    <th>RRI Min</th>
                    <th>HRV</th>
                    <th>Duration</th>
                    <th>Respiratory Rate</th>
                    <th>As on</th>
                    </tr>
                    {
                        patientDetails.map((element,key) => {
                            return (
                              
                                <tr className={key===0&&'patient-vitals-list_active'} key={key}>
                                <td> <Ecgicon/></td>
                                <td className="value">{element.heart_rate} <span className='unit'>bpm</span></td>
                                <td  className="value">{element.rri_maximum}<span className='unit'>ms</span></td>
                                <td  className="value">{element.rri_minimum}<span className='unit'>ms</span></td>
                                <td  className="value">{element.hrv}<span className='unit'>ms</span></td>
                                <td  className="value">{element.duration}<span className='unit'>sec</span></td>
                                <td  className="value">{element.respiratory_rate} <span className='unit'>bpm</span></td>
                                <td><span className='unit'>{element.date}</span></td>
                                </tr>
                                
                            )

                        })
                    }

                </table>

                /* <ul className='patient-vitals-list ecg'>
                    
                   {
                        patientDetails.map((element,key) => {
                            return (
                                <li className={key===0&&'patient-vitals-list_active'} key={key}>

                                    <table>
                                        <tr>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                        </tr>
                                    </table>
                                    <div className="left">
                                      <Ecgicon/>

                                        <span className='item'>Pulse Rate</span>
                                        <span className='value'>{element.heart_rate}</span>
                                        <span className='unit'>bpm</span>
                                    </div>
                                    
                                    <div className="left">
                                        <span className='item'>RRI Max</span>
                                        <span className='value'>{element.rri_maximum}</span>

                                    </div>
                                    <div className="left">
                                        <span className='item'>RRI Min</span>
                                        <span className='value'>{element.rri_minimum}</span>

                                    </div>
                                    <div className="left">
                                        <span className='item'>HRV</span>
                                        <span className='value'>{element.hrv}</span>

                                    </div>
                                    <div className="left">
                                        <span className='item'>Duration</span>
                                        <span className='value'>{element.duration}</span>

                                    </div>
                                    <div className="left">
                                        <span className='item'>Respiratory Rate</span>
                                        <span className='value'>{element.respiratory_rate}</span>

                                    </div>
                                   
                                    <div className="left">

                                        <span className='unit'>as on {element.date}</span>
                                    </div>
                                </li>
                            )
                        })
                    } 
                </ul> */
            ):"No Data Available"
                    }

            </div>

            {/* <div className="blood-pressure-vital-container_graph">
                
                <span className="title">Average Blood Pressure - Last 10 readings</span>

                <div className="dummy-graph"> (Graph)</div>

            </div> */}

        </div>
    )
}

export default ECG